/** Creates an array validator that returns the array as T[] if all values supported or null. */
export const createArrayCaster = <T>(supportedValues: T[]) => (
  suspectArray: unknown[] | undefined
) => {
  if (!suspectArray) {
    return null;
  }
  for (const value of suspectArray) {
    if (!supportedValues.includes(value as T)) {
      return null;
    }
  }
  return suspectArray as T[];
};
